var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgSocial = function SvgSocial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0C5.82 0 0 5.82 0 13s5.82 13 13 13 13-5.82 13-13S20.18 0 13 0zm.787 8.99a2.274 2.274 0 012.21-2.814 2.277 2.277 0 012.276 2.275 2.277 2.277 0 01-2.275 2.275 2.27 2.27 0 01-1.672-.733l-4.116 2.346a2.269 2.269 0 010 1.324l4.116 2.346a2.27 2.27 0 011.672-.734 2.277 2.277 0 012.275 2.275 2.277 2.277 0 01-2.275 2.275 2.277 2.277 0 01-2.21-2.813l-4.172-2.379c-.41.398-.969.643-1.583.643A2.277 2.277 0 015.758 13a2.277 2.277 0 012.275-2.275c.615 0 1.173.245 1.583.642l4.171-2.378z",
    fill: "currentColor"
  })));
};
export default SvgSocial;